import React from 'react';
import { MagnifyingGlassIcon, MixerHorizontalIcon } from '@radix-ui/react-icons';

export default function FiltersBar({ filters, setFilters, items }) {
  const categories = [...new Set(items.map((i) => i.category).filter(Boolean))];
  const vendors = [...new Set(items.map((i) => i.vendorName).filter(Boolean))];

  return (
    <>
      <div className="search-wrapper">
        <MagnifyingGlassIcon className="search-icon" />
        <input
          type="text"
          placeholder="Search Products and Services"
          value={filters.search}
          onChange={(e) => setFilters((f) => ({ ...f, search: e.target.value, page: 1 }))}
          className="search-input"
        />
      </div>

      <div className="filter-bar">
        <div className="filter-label">
          <MixerHorizontalIcon className="filter-icon" />
          <span>Filter by</span>
        </div>

        <div className="filter-controls">
          <select
            value={filters.category}
            onChange={(e) => setFilters((f) => ({ ...f, category: e.target.value, page: 1 }))}
          >
            <option value="">All Categories</option>
            {categories.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>

          <select
            value={filters.vendor}
            onChange={(e) => setFilters((f) => ({ ...f, vendor: e.target.value, page: 1 }))}
          >
            <option value="">All Vendors</option>
            {vendors.map((v) => (
              <option key={v} value={v}>
                {v}
              </option>
            ))}
          </select>

          <select
            value={filters.type}
            onChange={(e) => setFilters((f) => ({ ...f, type: e.target.value, page: 1 }))}
          >
            <option value="">All Types</option>
            <option value="product">Product</option>
            <option value="service">Service</option>
          </select>
        </div>
      </div>
    </>
  );
}
